import { EnumCurrency } from 'tdc-web-backend/enums/enums';

export default {
  body: {
    projectDurationFrom: '',
    projectDurationTo: '',
    buyer: {
      companyName: '',
      registeredAddress: '',
      companyNumber: '',
      companyRepresentative: {
        name: '',
        jobTitle: '',
        email: '',
      },
    },
    seller: {
      companyName: '',
      registeredAddress: '',
      companyNumber: '',
      companyRepresentative: {
        name: '',
        jobTitle: '',
        email: '',
      },
    },
    scope: {
      services: [],
      industry: '',
      currency: EnumCurrency.Eur,
      projectType: 'one_time',
      paymentTermsDays: 0,
      description: '',
    },
    milestones: [
      {
        name: '',
        start: '',
        end: '',
        budget: 0,
        summary: '',
        duration: null,
        recurring: false,
        paymentTermsDays: 0,
      },
    ],
    jurisdiction: '',
  },
  start: '',
  end: '',
  initialAmount: 0,
  sellerApproved: false,
  buyerApproved: false,
};

export const projectDurationInfo =
  'Project duration data will be calculated from your project milestone start and end dates';
